var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110 0C49.2529 0 0 49.2707 0 110C0 170.765 49.2529 220 110 220C170.747 220 220 170.765 220 110C220 49.2707 170.747 0 110 0ZM110 48.7903C120.289 48.7903 128.629 57.1308 128.629 67.4194C128.629 77.7079 120.289 86.0484 110 86.0484C99.7115 86.0484 91.371 77.7079 91.371 67.4194C91.371 57.1308 99.7115 48.7903 110 48.7903ZM134.839 161.452C134.839 164.391 132.456 166.774 129.516 166.774H90.4839C87.5445 166.774 85.1613 164.391 85.1613 161.452V150.806C85.1613 147.867 87.5445 145.484 90.4839 145.484H95.8065V117.097H90.4839C87.5445 117.097 85.1613 114.714 85.1613 111.774V101.129C85.1613 98.1896 87.5445 95.8065 90.4839 95.8065H118.871C121.81 95.8065 124.194 98.1896 124.194 101.129V145.484H129.516C132.456 145.484 134.839 147.867 134.839 150.806V161.452Z",
    fill: "#88A8E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.43f4be93c09af046c8c1aeaacba2b505.svg";
export { ForwardRef as ReactComponent };